import React from "react";
import { Redirect, Route } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // ✅ correct for jwt-decode v4+

function ProtectedRoute({ component: Component, ...restOfProps }) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.auth?.token;

  let isTokenValid = false;

  if (token) {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);

      if (decoded.exp && decoded.exp > currentTime) {
        isTokenValid = true;
      } else {
        console.warn("Token expired — clearing localStorage.");
        localStorage.clear();
      }
    } catch (err) {
      console.error("Invalid token:", err);
      localStorage.removeItem("state");
      localStorage.removeItem("isAuthenticated");
    }
  }

  const isAuthenticated = localStorage.getItem("isAuthenticated");

  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isTokenValid && isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/signin" />
        )
      }
    />
  );
}

export default ProtectedRoute;
